import type { HTMLAttributes, ReactNode } from 'react';
import './FieldError.css';

export interface FieldErrorProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'role'> {
  /** Id referenced by the control's aria-describedby. */
  id: string;
  /** The translated validation message. */
  children: ReactNode;
  className?: string;
}

/**
 * FieldError — the validation message under a custom form control
 * (rich-text editor, upload field, checkbox group …) that has no built-in
 * `error` prop. Input/Select/Textarea/NumericParameterInput render their own.
 *
 * Text (never colour-only), linked to the control via `aria-describedby={id}`,
 * announced when it appears (`role="alert"`). Page/form-level messages use
 * `<Alert>` instead.
 */
export function FieldError({ id, children, className = '', ...rest }: FieldErrorProps) {
  return (
    <span id={id} role="alert" className={['rg-field-error', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </span>
  );
}
